const approval = {
  vehicle: {
    pending: '/approvals/vehicle-approval/pending',
    history: '/approvals/vehicle-approval/history'
  },
  driver: {
    pending: '/approvals/driver-approval/pending',
    history: '/approvals/driver-approval/history'
  },
  location: {
    pending: '/approvals/location-approval/pending',
    history: '/approvals/location-approval/history'
  },
  customer: {
    pending: '/approvals/customer-approval/pending',
    history: '/approvals/customer-approval/history'
  },
  employee: {
    pending: '/approvals/employee-approval/pending',
    history: '/approvals/employee-approval/history'
  },
  vendor: {
    pending: '/approvals/vendor-approval/pending',
    history: '/approvals/vendor-approval/history'
  },
  Regularvendor: {
    pending: '/approvals/regular-approval/pending',
    history: '/approvals/regular-approval/history'
  },
  Trucker: {
    pending: '/approvals/trucker-approval/pending',
    history: '/approvals/trucker-approval/history'
  },
  FuelRetailer: {
    pending: '/approvals/fuelretailer-approval/pending',
    history: '/approvals/fuelretailer-approval/history'
  },
  branch: {
    pending: '/approvals/branch-approval/pending',
    history: '/approvals/branch-approval/history'
  },
  route: {
    pending: '/approvals/route-approval/pending',
    history: '/approvals/route-approval/history'
  },
  leave: {
    pending: '/approvals/leave-approval/pending',
    history: '/approvals/leave-approval/history'
  },
  do: {
    pending: '/approvals/do-approval/pending',
    history: '/approvals/do-approval/history'
  },
  po: {
    pending: '/approvals/po-approval/pending',
    history: '/approvals/po-approval/history'
  },
  permit: {
    pending: '/approvals/permit-approval/pending',
    history: '/approvals/permit-approval/history'
  },
  department: {
    pending: '/approvals/department-approval/pending',
    history: '/approvals/department-approval/history'
  },
  designation: {
    pending: '/approvals/designation-approval/pending',
    history: '/approvals/designation-approval/history'
  },
  shift: {
    pending: '/approvals/shift-approval/pending',
    history: '/approvals/shift-approval/history'
  },
  holidays: {
    pending: '/approvals/holidays-approval/pending',
    history: '/approvals/holidays-approval/history'
  },
  material: {
    pending: '/approvals/material-approval/pending',
    history: '/approvals/material-approval/history'
  },
  vehicleType: {
    pending: '/approvals/vehicleType-approval/pending',
    history: '/approvals/vehicleType-approval/history'
  },
  casualBreak: {
    pending: '/approvals/casualBreak-approval/pending',
    history: '/approvals/casualBreak-approval/history'
  },
  outerWorking: {
    pending: '/approvals/outerWorking-approval/pending',
    history: '/approvals/outerWorking-approval/history'
  },
  challan: {
    pending: '/approvals/challan-approval/pending',
    history: '/approvals/challan-approval/history',
    podApproval: '/approvals/challan-approval/podApproval'
  },
  manualPunch: {
    pending: '/approvals/manualPunch-approval/pending',
    history: '/approvals/manualPunch-approval/history'
  },
  latePunchin: {
    pending: '/approvals/latePunchin-approval/pending',
    history: '/approvals/latePunchin-approval/history'
  }
};

export default approval;
